import _, { replace } from 'lodash';
import { message } from 'antd';
import oss from 'ali-oss';

export const getFileType = (fileType: any) => {
  const [_, type] = fileType.split('/');
  return type;
};

export const uploadTypeValidChecker = async (
  file: any,
  props: any,
  calledBy: boolean | 'videoFunc' | 'imageFunc' = false,
) => {
  const {
    helper: { tx },
  } = props;

  // 检查上传文件类型
  const fileType = getFileType(file.type);

  const isLt10M = file.size / 1024 / 1024 < 10;
  const videoDurationPoint = 60;

  // 视频校验
  const validVideoType = [
    'mp4',
    'mov',
    'quicktime',
    'avi',
    'navi',
    'dv-avi',
    'divx',
    'asf',
    'wmv',
    'rm',
    'rmvb',
  ];

  if (calledBy === 'videoFunc' && validVideoType.includes(fileType)) {
    // 校验视频长度，，由于要校验视频的长度得获取到视频的内容，而这个等待是个异步所以需要把uploadTypeValidChecker变成异步，之后调用的时候可以用then/catch
    const duration = await checkVideoDuration(file);

    if (Number(duration) < videoDurationPoint) {
      return 'isUploadingViedo';
    } else {
      message.error('Video uploaded must less than 1 min');
      return false;
    }
  }

  // 视频的话弹支持的格式错误信息
  if (calledBy === 'videoFunc' && !validVideoType.includes(fileType)) {
    message.error(tx('Global.please_upload_video'));
    return false;
  }

  // 图片校验
  const validImageType = ['jpeg', 'png', 'bmp', 'gif', 'webp', 'jpg'];
  // 校验图片大小
  if (calledBy === 'imageFunc' && validImageType.includes(fileType)) {
    if (isLt10M) {
      return 'isUploadingImage';
    } else {
      message.error(tx('Global.image_uploaded_must_less_than_10mb'));
      return false;
    }
  }

  //图片的话弹图片错误信息
  if (calledBy === 'imageFunc' && !validVideoType.includes(fileType)) {
    message.error(tx('Global.please_upload_image'));
    return false;
  }

  // 既不是图片又不是视频的校验和错误信息
  if (!calledBy) {
    message.error(tx('Global.invalid_type'));
    return false;
  }

  // 成功上传后
  return true;
};

// 以下代码参考 https://codeantenna.com/a/RUMQYezRv0
// 视频时长判断大小时，会存在双层函数嵌套，内部函数为异步的情况，单纯return 是不行的。所以这里需要使用promise
export const checkVideoDuration = (file: any) => {
  return new Promise(resolve => {
    // 第一步，为这个视频创建一个指向该参数对象的URL
    // 具体createObjectUrl解释参考 https://github.com/cy0707/Learn_JavaScript/issues/34
    const videoUrl = URL.createObjectURL(file);

    // 第二步，创建一个视频元素并且视频的元数据加载结束时候会发生 loadedmetadata 事件
    const videoObj = document.createElement('video');
    videoObj.preload = 'metadata';
    videoObj.src = videoUrl;

    videoObj.onloadedmetadata = () => {
      //第三步， 当监听到了onloadedmetadata之后释放指向该参数对象的URL，具体解释(https://github.com/cy0707/Learn_JavaScript/issues/34)
      URL.revokeObjectURL(videoUrl);
      //第四步， 获取该视频的长度
      const videoDuration = Math.round(videoObj.duration);
      resolve(videoDuration);
    };
  });
};

export const uploadToOss = (file: any, stsPayload: any, localPayload: any) => {
  const {
    ossSettings: {
      ossTokens,
      callBack: { callbackUrl, callbackBody, callbackBodyType },
      customValue,
    },
    ossPathTable,
  } = stsPayload;

  const ossClient = new oss({ ...ossTokens });

  //这里根据localPayload来确定上传路径
  const url = uploadPath(file, ossPathTable, localPayload);
  console.log('[DEBUG] image tool url is ', url);

  const newCustomValue: any = {
    ...customValue,
    var2: localPayload.uploadType, //这个是谁要上传
    var3: String(localPayload.uploadId), //这个是上传者的id
    var4: localPayload.itemType, //上传什么东西
    var5: localPayload.timeStamp, //random数字 现在是用时间戳
    var6: localPayload.action, //这个是告诉后端什么动作
    var7: String(localPayload.videoCoverTimeStamp), //这个是告诉后端视频第几帧
  };

  //for test
  // const newCallBackUrl = 'http://47342d3e0769.ngrok.io/api/oss_callback';

  const callback = {
    url: callbackUrl,
    body: callbackBody,
    contentType: callbackBodyType,
    customValue: newCustomValue,
  };

  return new Promise((resolve, reject) => {
    ossClient
      .put(url, file, {
        callback,
      })
      .then((data: any) => {
        resolve(data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const uploadPath = (file: any, ossPathTable: any, localPayload: any) => {
  let uploadUrlString: string = '';

  const fileType = getFileType(file.type);

  const { businessId = false, uploadId = false, itemType, uploadType, timeStamp } = localPayload;

  const validUploadTypes = ['user', 'dish', 'menu', 'event', 'deal', 'business', 'modifier_item'];
  const generalValidUploadTypes = ['dish', 'menu', 'event', 'deal', 'modifier_item'];

  const allValidItemTypes = ['avatar', 'images', 'logo', 'cover'];
  const businessValidItemTypes = ['cover', 'images', 'logo'];
  const generalValidItemTypes = ['cover', 'images'];

  // 全局检查传入的值是否有效
  if (validUploadTypes.includes(uploadType) && allValidItemTypes.includes(itemType)) {
    // 处理 user avatar 的情况
    if (uploadType === 'user' && itemType === 'avatar') {
      uploadUrlString = getUploadUrlString(
        'user',
        'avatar',
        ossPathTable,
        uploadId,
        fileType,
        false,
        timeStamp,
      );
    }

    // 处理 其他图片上传的情况 （包括: deal, dish, event, menu)
    if (
      generalValidUploadTypes.includes(uploadType) &&
      generalValidItemTypes.includes(itemType) &&
      businessId
    ) {
      if (itemType === 'cover') {
        uploadUrlString = getUploadUrlString(
          uploadType,
          'cover',
          ossPathTable,
          uploadId,
          fileType,
          businessId,
          timeStamp,
        );
      } else if (itemType === 'images') {
        uploadUrlString = getUploadUrlString(
          uploadType,
          'images',
          ossPathTable,
          uploadId,
          fileType,
          businessId,
          timeStamp,
        );
      }
    }

    // 处理 商家上传的情况
    if (uploadType === 'business' && businessValidItemTypes.includes(itemType)) {
      if (itemType === 'logo') {
        uploadUrlString = getUploadUrlString(
          'business',
          'logo',
          ossPathTable,
          uploadId,
          fileType,
          false,
          timeStamp,
        );
      } else if (itemType === 'cover' && businessId) {
        uploadUrlString = getUploadUrlString(
          'business',
          'cover',
          ossPathTable,
          uploadId,
          fileType,
          businessId,
          timeStamp,
        );
      } else if (itemType === 'images' && businessId) {
        uploadUrlString = getUploadUrlString(
          uploadType,
          'images',
          ossPathTable,
          uploadId,
          fileType,
          businessId,
          timeStamp,
        );
      }
    }
  }
  return uploadUrlString;
};

export const getUploadUrlString = (
  uploadType: string,
  itemType: string,
  ossPathTable: any,
  uploadId: string,
  fileType: string,
  businessId = false,
  timeStamp = false,
) => {
  // 第一步 - 将 path table转换成 camel case
  const pathTable = _.camelCase(`${uploadType}_${itemType}`);

  // 第二步 - 构造要replace函数
  const replaceFormat = (data: string) => data.replace('{format}', fileType);
  const replaceBusinessId = (data: string) => data.replace('{business_id}', String(businessId));
  const replaceFormatAndBusiness = (data: string) => replaceFormat(replaceBusinessId(data));

  let uploadUrlString = 'unset';

  // 更改businessId, format, md5
  if (businessId && timeStamp) {
    uploadUrlString = replaceFormatAndBusiness(
      String(ossPathTable[pathTable])
        .replace(`{${uploadType}_id}`, uploadId)
        .replace('{md5}', String(timeStamp)),
    );
  }

  // 更改businessId, format
  if (businessId && !timeStamp) {
    uploadUrlString = replaceFormatAndBusiness(
      String(ossPathTable[pathTable]).replace(`{${uploadType}_id}`, uploadId),
    );
  }

  // 更改format
  if (!businessId) {
    uploadUrlString = replaceFormat(
      String(ossPathTable[pathTable])
        .replace(`{${uploadType}_id}`, uploadId)
        .replace('{md5}', String(timeStamp)),
    );
  }
  return uploadUrlString;
};

export const customisedMediaUrl = (baseUrl: string, width = 96, height = 96, roundedCorner = 1) => {
  const customisedURL = `${baseUrl}?x-oss-process=image/resize,m_fill,h_${height},w_${width}/rounded-corners,r_${roundedCorner}`;

  return customisedURL;
};

export const getImgType = (inputString: string) => inputString.split('image/')[1];

export const getVideoCover = (videoUrl: string, videoTimeStamp = '1000') => {
  // 参考 https://blog.csdn.net/qq_27295403/article/details/89176708
  const coverImg = `${videoUrl}?x-oss-process=video/snapshot,t_${videoTimeStamp},ar_auto,m_fast`;

  return coverImg;
};
